export const TUTORIAL_IDS = {
  IMAGE_TOOLS: "image_tools",
  MEASUREMENT_TOOL_TOOLBAR: "measurement_tool_toolbar",
  MEASUREMENT_TOOL_EDITING: "measurement_tool_editing",
  ANNOTATION_TOOL_TOOLBAR: "annotation_tool_toolbar",
  FORUM_HOME: "forum_home",
  FORUM_TOPIC_TAGS: "forum_topic_tags",
  FORUM_TOP_CONTRIBUTORS: "forum_top_contributors",
  FORUM_TABLE_OF_CONTENTS: "forum_table_of_contents",
  FORUM_COMMUNITY_NOTES: "forum_community_notes",
  FORUM_POST_BUTTONS: "forum_post_buttons",
  UPLOADER_COPY_DATA: "uploader_copy_data",
  MESSAGES_REFRESH: "messages_refresh"
};

// Define tutorial templates with translation keys
export const TUTORIAL_TEMPLATES = {
  IMAGE_TOOLS: {
    id: TUTORIAL_IDS.IMAGE_TOOLS,
    steps: [
      {
        id: "menu-button",
        selector: "[data-tutorial-id='image-tools-menu']",
        content: "", // Content will be populated by TutorialFactoryService
        placement: "bottom"
      }
    ]
  },

  MEASUREMENT_TOOL_TOOLBAR: {
    id: TUTORIAL_IDS.MEASUREMENT_TOOL_TOOLBAR,
    steps: [
      {
        id: "toolbar-help",
        selector: "[data-tutorial-id='measurement-help']",
        content: "", // Content will be populated by TutorialFactoryService
        placement: "bottom"
      },
      {
        id: "toolbar-saved",
        selector: "[data-tutorial-id='measurement-bookmarks']",
        content: "", // Content will be populated by TutorialFactoryService
        placement: "bottom"
      },
      {
        id: "toolbar-share",
        selector: "[data-tutorial-id='measurement-share']",
        content: "", // Content will be populated by TutorialFactoryService
        placement: "bottom"
      },
      {
        id: "toolbar-clear",
        selector: "[data-tutorial-id='measurement-clear']",
        content: "", // Content will be populated by TutorialFactoryService
        placement: "bottom"
      },
      {
        id: "draw-line",
        selector: "[data-tutorial-id='measurement-tool-canvas']",
        content: "", // Content will be populated by TutorialFactoryService
        placement: "top"
      }
    ]
  },

  MEASUREMENT_TOOL_EDITING: {
    id: TUTORIAL_IDS.MEASUREMENT_TOOL_EDITING,
    steps: [
      {
        id: "measurement-distance",
        selector: "[data-tutorial-id='measurement-distance-box']",
        content: "", // Content will be populated by TutorialFactoryService
        placement: "top"
      },
      {
        id: "toggle-shape-circle",
        selector: "[data-tutorial-id='circle-button']",
        content: "", // Content will be populated by TutorialFactoryService
        placement: "bottom"
      },
      {
        id: "toggle-shape-rectangle",
        selector: "[data-tutorial-id='rectangle-button']",
        content: "", // Content will be populated by TutorialFactoryService
        placement: "bottom"
      },
      {
        id: "export-coordinates",
        selector: "[data-tutorial-id='export-button']",
        content: "", // Content will be populated by TutorialFactoryService
        placement: "bottom"
      },
      {
        id: "save-measurements",
        selector: "[data-tutorial-id='save-measurement-button']",
        content: "", // Content will be populated by TutorialFactoryService
        placement: "bottom"
      }
    ]
  },

  ANNOTATION_TOOL_TOOLBAR: {
    id: TUTORIAL_IDS.ANNOTATION_TOOL_TOOLBAR,
    steps: [
      {
        id: "annotation-help",
        selector: "[data-tutorial-id='annotation-help']",
        content: "", // Content will be populated by TutorialFactoryService
        placement: "bottom"
      },
      {
        id: "annotation-rectangle",
        selector: "[data-tutorial-id='annotation-rectangle']",
        content: "", // Content will be populated by TutorialFactoryService
        placement: "bottom"
      },
      {
        id: "annotation-circle",
        selector: "[data-tutorial-id='annotation-circle']",
        content: "", // Content will be populated by TutorialFactoryService
        placement: "bottom"
      },
      {
        id: "annotation-text",
        selector: "[data-tutorial-id='annotation-text']",
        content: "", // Content will be populated by TutorialFactoryService
        placement: "bottom"
      },
      {
        id: "annotation-link",
        selector: "[data-tutorial-id='annotation-link']",
        content: "", // Content will be populated by TutorialFactoryService
        placement: "bottom"
      },
      {
        id: "annotation-save",
        selector: "[data-tutorial-id='annotation-save']",
        content: "", // Content will be populated by TutorialFactoryService
        placement: "bottom"
      },
      {
        id: "annotation-share",
        selector: "[data-tutorial-id='annotation-share']",
        content: "", // Content will be populated by TutorialFactoryService
        placement: "bottom"
      },
      {
        id: "annotation-clear",
        selector: "[data-tutorial-id='annotation-clear']",
        content: "", // Content will be populated by TutorialFactoryService
        placement: "bottom"
      },
      {
        id: "annotation-exit",
        selector: "[data-tutorial-id='annotation-exit']",
        content: "", // Content will be populated by TutorialFactoryService
        placement: "bottom"
      }
    ]
  },

  FORUM_HOME: {
    id: TUTORIAL_IDS.FORUM_HOME,
    unskippable: true,
    enableNotNow: true,
    steps: [
      {
        id: "feed-dropdown",
        selector: "[data-tutorial-id='forum-feed-dropdown']",
        content: "",
        placement: "bottom"
      },
      {
        id: "tags-button",
        selector: "[data-tutorial-id='forum-tags-button']",
        content: "",
        placement: "bottom"
      },
      {
        id: "new-topic-button",
        selector: "[data-tutorial-id='forum-new-topic-button']",
        content: "",
        placement: "bottom"
      },
      {
        id: "search-bar",
        selector: "[data-tutorial-id='forum-search-bar']",
        content: "",
        placement: "bottom"
      },
      {
        id: "topic-tags",
        selector: "[data-tutorial-id='forum-topic-tags']",
        content: "",
        placement: "top"
      },
      {
        id: "post-quality-panel",
        selector: "[data-tutorial-id='forum-post-quality-panel']",
        content: "",
        placement: "left"
      },
      {
        id: "recommended-tags",
        selector: "[data-tutorial-id='forum-recommended-tags']",
        content: "",
        placement: "left"
      },
      {
        id: "random-image",
        selector: "[data-tutorial-id='forum-random-image']",
        content: "",
        placement: "bottom"
      }
    ]
  },

  FORUM_TOPIC_TAGS: {
    id: TUTORIAL_IDS.FORUM_TOPIC_TAGS,
    unskippable: true,
    enableNotNow: true,
    steps: [
      {
        id: "topic-tags",
        selector: "[data-tutorial-id='topic-tags-area']",
        content: "",
        placement: "bottom"
      },
      {
        id: "edit-tags",
        selector: "[data-tutorial-id='edit-tags-button']",
        content: "",
        placement: "bottom"
      }
    ]
  },

  FORUM_TOP_CONTRIBUTORS: {
    id: TUTORIAL_IDS.FORUM_TOP_CONTRIBUTORS,
    unskippable: true,
    enableNotNow: true,
    steps: [
      {
        id: "top-contributors",
        selector: "[data-tutorial-id='topic-contributors']",
        content: "",
        placement: "bottom"
      }
    ]
  },

  FORUM_TABLE_OF_CONTENTS: {
    id: TUTORIAL_IDS.FORUM_TABLE_OF_CONTENTS,
    unskippable: true,
    enableNotNow: true,
    steps: [
      {
        id: "table-of-contents",
        selector: "[data-tutorial-id='topic-table-of-contents']",
        content: "",
        placement: "left"
      }
    ]
  },

  FORUM_COMMUNITY_NOTES: {
    id: TUTORIAL_IDS.FORUM_COMMUNITY_NOTES,
    unskippable: true,
    enableNotNow: true,
    steps: [
      {
        id: "community-notes",
        selector: "[data-tutorial-id='post-community-notes']",
        content: "",
        placement: "left"
      }
    ]
  },

  FORUM_POST_BUTTONS: {
    id: TUTORIAL_IDS.FORUM_POST_BUTTONS,
    unskippable: true,
    enableNotNow: true,
    steps: [
      {
        id: "add-community-note",
        selector: "[data-tutorial-id='add-community-note-button']",
        content: "",
        placement: "top"
      },
      {
        id: "recommend-expert",
        selector: "[data-tutorial-id='recommend-expert-button']",
        content: "",
        placement: "top"
      }
    ]
  },

  UPLOADER_COPY_DATA: {
    id: TUTORIAL_IDS.UPLOADER_COPY_DATA,
    steps: [
      {
        id: "copy-data-dropdown",
        selector: "[data-tutorial-id='copy-data-dropdown']",
        content: "", // Content will be populated by TutorialFactoryService
        placement: "top"
      }
    ]
  },

  MESSAGES_REFRESH: {
    id: TUTORIAL_IDS.MESSAGES_REFRESH,
    steps: [
      {
        id: "messages-refresh-announcement",
        selector: ".tutorial-center-anchor-that-does-not-exist", // Non-existent selector to trigger centered display
        content: "", // Content will be populated by TutorialFactoryService
        placement: "bottom"
      }
    ]
  }
};
